import React from 'react'
import { IASuggestionResponse } from '../../../../../../api/accordanceApi'
import './IAImproveText.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  suggestedText?: string;
  onUse: () => void;
  onDiscard: () => void;
};

export const IAImproveText = ({ suggestedText, onUse, onDiscard }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="ai-suggestion-response">
      <div className="ai-suggestion-response__content">
        <p>{suggestedText}</p>
      </div>

      <div className="ai-suggestion-response__footer">
        <div className="ai-suggestion-response__actions">
          <button className="ai-suggestion-response__use-button" type="button" onClick={onUse}>
            {t('use_proposal').toUpperCase()}
          </button>
          <button className="ai-suggestion-response__discard-button" type="button" onClick={onDiscard}>
            {t('discard').toUpperCase()}
          </button>
        </div>

        <p className="ai-suggestion-response__disclaimer">{t('content_generated_by_AI_can_be_incorrect')}</p>
      </div>
    </div>
  )
}
